module.exports = __webpack_public_path__ + "static/media/loanAppBorrower.748e5ad9.svg";